import React, { Fragment, useState, useEffect } from 'react';
import { Row, Col, Container, Card, Button } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShop, faBullhorn, faBusinessTime, faShopSlash, faFileSignature, faFileLines } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom';
import '../../../styles/diario.scss';


function LicitacaoLoggedScreen() {
    const [direct, setDirect] = useState(false);
    const [adm, setAdm] = useState(false);
    const [control, setControl] = useState(false);
    const nome = localStorage.getItem('nome');

    const getNivel = async () => {
        let user = localStorage.getItem('nivel');
        console.log(user)
        switch (user) {
            case "Administrador":
                await setDirect(false)
                await setAdm(true)
                break;
            case "Legislador":
                await setDirect("/restrito/leis")
                break;
            case "Licitador":
                await setDirect(false)
                break;
            case "Controle Interno":
                await setDirect(false)
                await setControl(true)
                break;
        }
    }


    const redireciona = async () => {
        await getNivel();
    }

    useEffect(() => {
        redireciona()
    }, [])


    if (direct) {
        return <Navigate to={{ pathname: `${direct}` }} />
    } else {
        return (
            <Fragment>
                <Container>
                    <h5>Bem vindo, {nome}, o que deseja fazer?</h5><br />
                    <Row xs={1} lg={3}>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/licitacao/cadastrar')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={2}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faShop} />
                                                </Col>
                                                <Col xs={10}>
                                                    <p className='titulo-lei lt-ft'>Cadastrar Licitação</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/licitacao/aviso')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={2}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faBullhorn} />
                                                </Col>
                                                <Col xs={10}>
                                                    <p className='titulo-lei lt-ft'>Cadastrar Aviso</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/licitacao/listar/todas')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={2}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faFileLines} />
                                                </Col>
                                                <Col xs={10}>
                                                    <p className='titulo-lei lt-ft'>Todas Licitações</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/licitacao/listar/avisos')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={2}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faFileLines} />
                                                </Col>
                                                <Col xs={10}>
                                                    <p className='titulo-lei lt-ft'>Avisos de Licitações</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/licitacao/listar/andamento')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={2}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faBusinessTime} />
                                                </Col>
                                                <Col xs={10}>
                                                    <p className='titulo-lei lt-ft'>Licitações em Andamento</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/licitacao/listar/encerradas')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={2}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faShopSlash} />
                                                </Col>
                                                <Col xs={10}>
                                                    <p className='titulo-lei lt-ft'>Licitações Encerradas</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/contratos')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={2}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faFileSignature} />
                                                </Col>
                                                <Col xs={10}>
                                                    <p className='titulo-lei lt-ft'>Contratos</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/restrito/contratos/chamamento')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={2}>
                                                <Col xs={2}>
                                                    <FontAwesomeIcon className='icon-cad' icon={faBullhorn} />
                                                </Col>
                                                <Col xs={10}>
                                                    <p className='titulo-lei lt-ft'>Chamamentos da Saúde</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        
                    </Row>
                    {adm ?
                        <Fragment>
                            <br /><br />
                            <Link to={'/restrito'}>
                                <Button variant="danger" type="button">
                                    Voltar
                                </Button>
                            </Link>
                        </Fragment> : ''}
                    {control ?
                        <Fragment>
                            <br /><br />
                            <Link to={'/restrito/controle'}>
                                <Button variant="danger" type="button">
                                    Voltar
                                </Button>
                            </Link>
                        </Fragment> : ''}
                </Container>
            </Fragment>
        );
    }
}

export default LicitacaoLoggedScreen;